import React from "react";
import { Box, Typography } from "@mui/material";
import Langs from "../../app/lang/langs";

/**
 * Legend chip explaining that blue-tinted columns/fields hold data
 * synced from Silae. Same blue as the .silaeHeader/.silaeCell CSS
 * classes and the mobile field accent (#0288d1).
 */
export function SilaeLegend({ sx }) {
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, ...sx }}>
      <Box
        sx={{
          width: 12,
          height: 12,
          borderRadius: "3px",
          backgroundColor: "rgba(2, 136, 209, 0.25)",
          border: "1px solid #0288d1",
          flexShrink: 0,
        }}
      />
      <Typography variant="caption" sx={{ color: "text.secondary", whiteSpace: "nowrap" }}>
        <Langs str="SILAE_LEGEND" />
      </Typography>
    </Box>
  );
}
